import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
function MessageNotifications(_ref) {
  var currentUserId = _ref.currentUserId,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    _ref$userRole = _ref.userRole,
    userRole = _ref$userRole === void 0 ? 'rep' : _ref$userRole;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hidden = _useState4[0],
    setHidden = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    open = _useState6[0],
    setOpen = _useState6[1];
  var _useState7 = useState({
      top: 0,
      left: 0
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    dropdownPos = _useState8[0],
    setDropdownPos = _useState8[1];
  var bellRef = useRef(null);
  var dropdownRef = useRef(null);
  useEffect(function () {
    try {
      if (typeof window !== 'undefined' && window.proposalResourceId) {
        var show = typeof window.showProposalMessages === 'boolean' ? window.showProposalMessages : true;
        setHidden(!show);
      } else {
        setHidden(false);
      }
    } catch (e) {
      setHidden(false);
    }
    var subscription = null;
    fetch('/notifications.json', {
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json();
    }).then(function (persisted) {
      if (Array.isArray(persisted)) {
        setItems(function (prev) {
          return [].concat(_toConsumableArray(persisted), _toConsumableArray(prev)).slice(0, 20);
        });
      }
    })["catch"](function () {});
    try {
      if (window.App && window.App.cable && currentUserId) {
        subscription = window.App.cable.subscriptions.create({
          channel: 'NotificationsChannel'
        }, {
          received: function received(data) {
            setItems(function (prev) {
              return [{
                title: data.title || 'New message',
                body: data.body || '',
                url: data.url || '#',
                created_at: data.created_at || new Date().toISOString()
              }].concat(_toConsumableArray(prev)).slice(0, 20);
            });
          }
        });
      }
    } catch (e) {/* noop */}
    var onClearForUrl = function onClearForUrl(e) {
      var _e$detail;
      var url = e === null || e === void 0 ? void 0 : (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.url;
      if (!url) return;
      setItems(function (prev) {
        return prev.filter(function (it) {
          return it.url !== url;
        });
      });
    };
    window.addEventListener('notifications:clear_for_url', onClearForUrl);
    return function () {
      if (subscription && window.App && window.App.cable) {
        window.App.cable.subscriptions.remove(subscription);
      }
      window.removeEventListener('notifications:clear_for_url', onClearForUrl);
    };
  }, [currentUserId]);

  // Close when clicking outside both the bell and the dropdown panel.
  useEffect(function () {
    if (!open) return undefined;
    var handleOutside = function handleOutside(e) {
      var bell = bellRef.current;
      var dropdown = dropdownRef.current;
      if (bell && bell.contains(e.target)) return;
      if (dropdown && dropdown.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', handleOutside);
    return function () {
      return document.removeEventListener('mousedown', handleOutside);
    };
  }, [open]);
  var handleToggle = function handleToggle() {
    if (!open && bellRef.current) {
      var rect = bellRef.current.getBoundingClientRect();
      // Reps: center dropdown under bell. Others: right-align to bell's right edge.
      setDropdownPos({
        top: rect.bottom + 4,
        left: userRole === 'rep' ? rect.left + rect.width / 2 : rect.right
      });
    }
    setOpen(function (prev) {
      return !prev;
    });
  };
  var count = items.length;
  if (hidden) return null;

  // Render dropdown at fixed viewport coordinates so it escapes any container
  // (collapsed navbar, overflow:hidden, CSS transforms, etc.)
  var dropdownStyle = _objectSpread({
    position: 'fixed',
    top: dropdownPos.top,
    left: dropdownPos.left,
    minWidth: '320px',
    zIndex: 1055
  }, userRole === 'rep' ? {
    transform: 'translateX(-50%)'
  } : {
    transform: 'translateX(-100%)'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "nav-msg-notifications",
    ref: bellRef
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link d-flex align-items-center",
    role: "button",
    tabIndex: 0,
    "aria-haspopup": "true",
    "aria-expanded": open,
    onClick: handleToggle,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleToggle();
      }
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa".concat(count > 0 ? 's' : 'r', " fa-bell")
  }), count > 0 && /*#__PURE__*/React.createElement("span", {
    className: "badge bg-danger ms-1 rounded-pill",
    style: {
      lineHeight: '12px',
      fontSize: '10px'
    }
  }, count > 10 ? '10+' : count)), open && /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("div", {
    ref: dropdownRef,
    className: "dropdown-menu show",
    style: dropdownStyle
  }, items.length === 0 && /*#__PURE__*/React.createElement("span", {
    className: "dropdown-item text-muted text-center"
  }, "No new messages"), items.map(function (it, idx) {
    return /*#__PURE__*/React.createElement("a", {
      key: "".concat(it.created_at, "-").concat(idx),
      className: "dropdown-item text-center",
      href: it.url,
      onClick: function onClick() {
        try {
          if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('notifications:clear_for_url', {
              detail: {
                url: it.url
              }
            }));
          }
          setItems(function (prev) {
            return prev.filter(function (_, i) {
              return i !== idx;
            });
          });
          setOpen(false);
        } catch (e) {/* noop */}
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "fw-bold"
    }, it.title), /*#__PURE__*/React.createElement("div", {
      className: "small text-muted"
    }, new Date(it.created_at).toLocaleString()));
  })), document.body));
}
MessageNotifications.propTypes = {
  currentUserId: PropTypes.number.isRequired,
  enabled: PropTypes.bool,
  userRole: PropTypes.string
};
export default MessageNotifications;